import { render, staticRenderFns } from "./gcamera-list.vue?vue&type=template&id=89681220&scoped=true"
import script from "./gcamera-list.vue?vue&type=script&lang=js"
export * from "./gcamera-list.vue?vue&type=script&lang=js"
import style0 from "./gcamera-list.vue?vue&type=style&index=0&id=89681220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89681220",
  null
  
)

export default component.exports